import { useState, useEffect } from 'react';

const DrcpForm = () => {
  const [formData, setFormData] = useState({
    date: '',
    districtName: '',
    sanctionedPosts: '',
    outsourcingAgency: '',
    sourceOfAgency: '',
    serviceCommission: '',
    postsRequired: '',
    blocks: '',
    proposalForwarded: '',
    remarks: ''
  });

  // Auto-fill blocks when postsRequired changes
  useEffect(() => {
    if (formData.postsRequired) {
      setFormData(prevData => ({
        ...prevData,
        blocks: prevData.postsRequired
      }));
    }
  }, [formData.postsRequired]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle form submission for update
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Data updated:', formData);
    // Update logic here
  };

  // Handle save button click
  const handleSave = () => {
    console.log('Data saved:', formData);
    // Save logic here
  };

  return (
    <div className="p-8 bg-white rounded-xl shadow-md border border-gray-100">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 border-b pb-3">Add New DRCP Entry</h2>
      
      <form className="space-y-6">
        {/* District and Agency Source */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label htmlFor="districtName" className="block text-sm font-medium text-gray-700 mb-1">
              Name of the District
            </label>
            <input
              type="text"
              id="districtName"
              name="districtName"
              value={formData.districtName}
              onChange={handleChange}
              readOnly
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-gray-50 text-gray-500 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label htmlFor="sourceOfAgency" className="block text-sm font-medium text-gray-700 mb-1">
              Source of Agency
            </label>
            <select
              id="sourceOfAgency"
              name="sourceOfAgency"
              value={formData.sourceOfAgency}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select Source</option>
              <option value="Government Supported">Government Supported</option>
              <option value="Private">Private</option>
            </select>
          </div>
        </div>

        {/* Outsourcing Agency and Service Commission */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label htmlFor="outsourcingAgency" className="block text-sm font-medium text-gray-700 mb-1">
              Name of Outsourcing Agency
            </label>
            <input
              type="text"
              id="outsourcingAgency"
              name="outsourcingAgency"
              value={formData.outsourcingAgency}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label htmlFor="serviceCommission" className="block text-sm font-medium text-gray-700 mb-1">
              % of Service Commission
            </label>
            <input
              type="number"
              id="serviceCommission"
              name="serviceCommission"
              step="0.01"
              value={formData.serviceCommission}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
        </div>

        {/* Posts Sanctioned and Posts Required */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* <div>
            <label htmlFor="sanctionedPosts" className="block text-sm font-medium text-gray-700 mb-1">
              No. of Posts Sanctioned
            </label>
            <input
              type="number"
              id="sanctionedPosts"
              name="sanctionedPosts"
              value={formData.sanctionedPosts}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            />
          </div> */}
          
          {/* <div>
            <label htmlFor="postsRequired" className="block text-sm font-medium text-gray-700 mb-1">
              No. of Posts Required
            </label>
            <input
              type="number"
              id="postsRequired"
              name="postsRequired"
              value={formData.postsRequired}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            />
          </div> */}
        {/* </div>

    
        <div>
          <div className="mb-4">
            <label htmlFor="blocks" className="block text-sm font-medium text-gray-700 mb-1">
              No. of Blocks
            </label>
            <input
              type="number"
              id="blocks"
              name="blocks"
              value={formData.blocks}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            />
         
          </div> */}
          
          {/* Save Button placed after No. of Blocks */}
          <div className="flex justify-start mt-4">
            <button 
              type="button" 
              onClick={handleSave}
              className="px-5 py-2.5 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 transition-colors"
            >
              Save
            </button>
          </div>
        </div>

        {/* Separator */}
        <div className="border-t border-gray-200 my-6"></div>

        {/* Date and Proposal Forwarded */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
              Date
            </label>
            <input
              type="date"
              id="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
              required
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          
          <div>
            <label htmlFor="proposalForwarded" className="block text-sm font-medium text-gray-700 mb-1">
              Proposal Forwarded to CRD Office
            </label>
            <select
              id="proposalForwarded"
              name="proposalForwarded"
              value={formData.proposalForwarded}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>

        {/* Remarks with Update Button */}
        <div>
          <div className="mb-4">
            <label htmlFor="remarks" className="block text-sm font-medium text-gray-700 mb-1">
              Remarks
            </label>
            <textarea
              id="remarks"
              name="remarks"
              rows="3"
              value={formData.remarks}
              onChange={handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500"
              placeholder="Add any additional notes or comments here..."
            />
          </div>
          
          {/* Update Button placed after Remarks */}
          <div className="flex justify-start mt-4">
            <button 
              type="button"
              onClick={handleSubmit}
              className="px-5 py-2.5 bg-green-600 text-white font-medium rounded-lg shadow hover:bg-green-700 focus:ring-4 focus:ring-green-300 transition-colors"
            >
              Update
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DrcpForm;